export enum FilterOptions {
  All = 'all',
  Active = 'active',
  Completed = 'completed',
}
